import { GET_SETTING_DATA, GET_SETTING_DATA_STATUS, GET_SETTING_USER_DATA, GET_SETTING_USER_DATA_STATUS } from "../constants";

const init: any = {
  setting: {},
  settingUserData: {},
  settingStatus: false,
  settingUserDataStatus: {},
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const CalculatorSettingReducer = (state: any = init, action: any): any => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (action.type) {
    case GET_SETTING_DATA: {
      return {
        ...state,
        setting: action.payload?.data,
        settingStatus: true,
        settingUserDataStatus: true,
      };
    }
    case GET_SETTING_USER_DATA: {
      return {
        ...state,
        settingUserData: action.payload?.data,
        settingUserDataStatus: true,
      };
    }
    case GET_SETTING_DATA_STATUS: {
      return {
        ...state,
        settingStatus: action.payload,
      };
    }
    case GET_SETTING_USER_DATA_STATUS: {
      return {
        ...state,
        settingUserDataStatus: action.payload,
      };
    }

    default:
      return state;
  }
};
export default CalculatorSettingReducer;
